export default __webpack_public_path__ + "static/media/client-22.8f20cc45.png";